<template>
	<div>
		<li @click="exportToExcel" class="dropdown-item p-0 py-2">
			<a class="pr-2">
				<icon icon="fad fa-file-excel" style="font-size: 15px" />
				<span class="mr-2">Excel</span>
			</a>
		</li>
		<li @click="exportToCsv" class="dropdown-item p-0 py-2">
			<a class="pr-2">
				<icon icon="fad fa-file-csv" style="font-size: 15px" />
				<span class="mr-2">Csv</span>
			</a>
		</li>
		<li @click="exportToPdfDialog" class="dropdown-item p-0 py-2">
			<a class="pr-2">
				<icon icon="fad fa-file-pdf" style="font-size: 15px" />
				<span class="mr-2">Pdf</span>
			</a>
		</li>
	</div>
</template>

<script>
	import { jsPDF } from 'jspdf'
	import autoTable from 'jspdf-autotable'
	import { base64 } from '~/assets/resources/f-iran-yekan-base64.js'
	import * as XLSX from 'xlsx/xlsx.mjs'
	import PdfExportDialog from '../table/pdf-export-dialog'
	import _ from 'lodash'

	export default {
		name: 'GridExporter',
		props: {
			filteredData: { type: Array, default() { return [] } },
			filteredColumns: { type: Array, default() { return [] } },
			stateUID: { type: String, default: '' }
		},
		methods: {
			dataOptimizer() {
				let headers = []
				const rows = []
				const result = []

				this.filteredData.forEach((dataRow) => {
					let row = []
					this.filteredColumns.forEach((col) => { // in foreach return equals to continue

						if (col.visibility) {

							if (col.exportHandler && typeof col.exportHandler === 'function') {
								row.push(col.exportHandler(dataRow, col))
								return
							}

							if (!dataRow[col.name] || typeof dataRow[col.name] === 'undefined' || dataRow[col.name].length === 0) {
								row.push('')
								return
							}

							if (this.isObject(dataRow[col.name])) {
								if (col.view && col.view.options) {
									row.push(col.view.options.format(dataRow[col.name]))
								}
							}

							else if (Array.isArray(dataRow[col.name])) {
								if (col.name === 'currencyValues') {
									let data = dataRow[col.name][0]
									let field = col.view().options.targetValuePropertyName

									if (!_.isEmpty(data[field])) {
										if (field === 'currency')
											row.push(data[field].name)
										else
											row.push(data[field])

									}
									else
										row.push('')
								}
							}

							else {
								if (col.name === 'date') {
									row.push(new Date(dataRow[col.name]).toLocaleDateString('fa-IR').toString().toEnglishDigits())
									return
								}
								row.push(dataRow[col.name])
							}
						}
					})
					rows.push(row)
				})

				this.filteredColumns.find((col) => {
					if (col.visibility) {
						headers.push(col.title)
					}
				})
				result.push(headers)

				rows.forEach((row) => {
					result.push(row)
				})

				return result
			},

			csvStringBuilder(data) {
				let csvString = ''

				data.forEach((rowItem) => {
					rowItem.forEach((colItem) => {
						csvString += colItem + ','
					})
					csvString += '\r\n'
				})

				csvString =
					'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvString)

				return csvString
			},

			prepareDataTable() {
				let head = []
				let body = []
				let result = {}

				this.filteredColumns.find((col) => {
					if (col.visibility) {
						head.push(col.title)
					}
				})

				for (let index = 0; index < this.filteredData.length; index++) {
					const dataRow = this.filteredData[index]

					var aggregates = []
					let row = []
					this.filteredColumns.forEach((col) => { // in foreach return equals to continue

						if (col.visibility) {

							if (col.aggregates.length > 0) {
								col.aggregates.forEach((aggregate) => {

									if (aggregate.visibe && aggregate.visible) {
										if (!aggregate.title.length)
											aggregates.push([aggregate.value])

										else
											aggregates.push([aggregate.value + ' : ' + aggregate.title])
									}
								})
							} else {
								aggregates.push([])
							}

							if (col.exportHandler && typeof col.exportHandler === 'function') {
								row.push(col.exportHandler(dataRow, col))
								return
							}

							if (!dataRow[col.name] || typeof dataRow[col.name] === 'undefined' || dataRow[col.name].length === 0) {
								row.push('')
								return
							}

							if (this.isObject(dataRow[col.name])) {
								if (col.view && col.view.options) {
									row.push(col.view.options.format(dataRow[col.name]))
								}
							}

							else if (Array.isArray(dataRow[col.name])) {
								if (col.name === 'currencyValues') {
									let data = dataRow[col.name][0]
									let field = col.view().options.targetValuePropertyName

									if (!_.isEmpty(data[field])) {
										if (field === 'currency')
											row.push(data[field].name)
										else
											row.push(data[field])

									}
									else
										row.push('')
								}
							}

							else {
								if (col.name === 'date') {
									row.push(new Date(dataRow[col.name]).toLocaleDateString('fa-IR').toString().toEnglishDigits())
									return
								}
								row.push(dataRow[col.name])
							}
						}
					})
					body.push(row.reverse())
				}


				result = {
					head: [head.reverse()],
					body: body,
					foot: [aggregates.reverse()]
				}

				return result
			},

			exportToExcel() {
				if (!this.filteredData.length)
					return this.$toast(this.$t('table.export.is-empty'), { type: 'info' })
				const data = this.dataOptimizer()
				let ws = XLSX.utils.aoa_to_sheet(data)
				let wb = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(wb, ws, 'data')
				wb.Workbook = {}
				wb.Workbook['Views'] = [{ RTL: true }]
				if (this.stateUID && this.stateUID !== '') {
					XLSX.writeFile(wb, this.stateUID + '.xlsx')
				} else {
					XLSX.writeFile(wb, 'data.xlsx')
				}
			},

			exportToCsv() {
				if (!this.filteredData.length)
					return this.$toast(this.$t('table.export.is-empty'), { type: 'info' })
				const data = this.dataOptimizer()
				const csvString = this.csvStringBuilder(data)

				let x = document.createElement('A')
				x.setAttribute('href', csvString)

				if (this.stateUID && this.stateUID !== '') {
					x.setAttribute('download', this.stateUID + '.csv')
				} else {
					x.setAttribute('download', 'data.csv')
				}

				document.body.appendChild(x)
				x.click()
			},

			exportToPdfDialog() {
				if (!this.filteredData.length)
					return this.$toast(this.$t('table.export.is-empty'), { type: 'info' })
				this.showModal({ component: PdfExportDialog })
					.then((res) => {
						this.exportToPdf(res.paperSize, res.orientation, res.theme)
					})
					.catch((err) => {

					})
			},

			exportToPdf(paperSize, orientation, theme) {
				const dataTable = this.prepareDataTable()
				const doc = jsPDF({
					orientation: orientation,
					unit: 'px',
					format: paperSize,
					hotfixes: ['px_scaling'],
					compress: true
				})

				var font = base64
				doc.addFileToVFS('IranYekan-normal.ttf', font)
				doc.addFont('IranYekan-normal.ttf', 'IranYekan', 'normal')
				doc.setFont('IranYekan', 'normal')

				autoTable(doc, {
					head: dataTable.head,
					body: dataTable.body,
					foot: dataTable.foot,
					showFoot: 'lastPage',
					styles: { font: 'IranYekan', halign: 'right' },
					headStyles: theme !== 'plain' ? { fillColor: '#474197' } : {},
					footStyles: theme !== 'plain' ? { fillColor: '#474197' } : {},
					theme: theme
				})
				doc.save()
			}
		}
	}
</script>
